import type { FileError } from 'react-dropzone';

// Mirror of the backend Bedrock limits (apps/legacy-service/src/ai/bedrock-document-size.ts).
// Kept in sync by hand — the frontend can't import backend constants.
export const MAX_IMAGE_SIZE_BYTES = 3_932_160; // 3.75 MB
export const MAX_PDF_SIZE_BYTES = 33_554_432; // 32 MB

type Translate = (key: string, options?: Record<string, unknown>) => string;

/**
 * react-dropzone validator rejecting files past the Bedrock size limit so the
 * AI pipeline (classification/extraction/validity) never receives an oversized
 * document. Only images get the strict image cap; PDFs and files with an
 * unknown/empty MIME type get the larger PDF cap (mirrors the backend guard).
 */
export function makeAiSizeValidator(t: Translate) {
  return (file: File): FileError | null => {
    const limit = file.type.toLowerCase().startsWith('image/')
      ? MAX_IMAGE_SIZE_BYTES
      : MAX_PDF_SIZE_BYTES;
    if (file.size <= limit) return null;
    const fileSize = (file.size / (1024 * 1024))
      .toFixed(2)
      .replace(/\.?0+$/, '')
      .replace('.', ',');
    return {
      code: 'ai-file-too-large',
      message: t('fileInput.aiFileTooLarge', { fileSize, maxSize: '3,75', maxSizePdf: '32' }),
    };
  };
}
